'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _HeaderSignup = require('./HeaderSignup.css');

var _HeaderSignup2 = _interopRequireDefault(_HeaderSignup);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import convert from '../../helpers/convert'
// import ReactTooltip from 'react-tooltip'
// import format from '../../helpers/format'

var HeaderSignup = (_dec = (0, _reactCssModules2.default)(_HeaderSignup2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HeaderSignup, _Component);

  function HeaderSignup(props) {
    (0, _classCallCheck3.default)(this, HeaderSignup);
    return (0, _possibleConstructorReturn3.default)(this, (HeaderSignup.__proto__ || (0, _getPrototypeOf2.default)(HeaderSignup)).call(this, props));
  }

  (0, _createClass3.default)(HeaderSignup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'hidden-xs form-wrap' },
        _react2.default.createElement(
          'form',
          { styleName: 'form',
            acceptCharset: 'UTF-8',
            method: 'post',
            action: _config2.default.signupForm.url,
            target: 'signup_confirmation',
            ref: function ref(el) {
              return _this2.myFormRef = el;
            } },
          _react2.default.createElement('input', { styleName: 'input',
            name: _config2.default.signupForm.id,
            type: 'email',
            placeholder: 'Get email updates',
            required: true }),
          _react2.default.createElement(
            'div',
            { style: {
                position: 'absolute',
                left: '-9999px',
                top: '-9999px'
              } },
            _react2.default.createElement(
              'label',
              { htmlFor: 'pardot_extra_field' },
              'Comments'
            ),
            _react2.default.createElement('input', { type: 'text', id: 'pardot_extra_field', name: 'pardot_extra_field' })
          ),
          _react2.default.createElement(
            'button',
            { styleName: 'submit',
              type: 'submit' },
            'Sign up',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope-o' })
          )
        )
      );
    }
  }]);
  return HeaderSignup;
}(_react.Component)) || _class);
exports.default = HeaderSignup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/HeaderSignup/HeaderSignup.js
// module id = 1360
// module chunks = 0